import '../../Reports/reports.scss';

import { format } from 'date-fns';
import { CircularProgress } from 'material-ui';
import * as React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

import { deleteForm } from '../../../services/plantService';
import { FormFooter } from '../../reusableComponents/FormComponents/FormFooter';

export interface IFooterCardProps {
    id: string;
    onClick: Function;
    isClickable: boolean;
    plantUID: string;
    label: string | JSX.Element;
    date: Date;
    outfall?: string;
    popOverContent?: JSX.Element;
    customPopover?: JSX.Element;
    completedOutFalls?: string[];
    isVisible: boolean;
}

export interface IFooterCardState {
    isLoading: boolean;
}

export class FooterCard extends React.PureComponent<IFooterCardProps, IFooterCardState> {
    constructor(props: IFooterCardProps) {
        super(props);
        this.state = { isLoading: false };
    }

    deletePlant = async (plantUID, formType, outFall) => {
        this.setState({
            isLoading: true
        });
        await deleteForm(format(this.props.date, 'MMDDYYYY'), plantUID, formType, this, outFall);
        this.setState({
            isLoading: false
        });
        document.body.click();
    }

    renderPopOverTop = (plantUID: string, formType: string, outFall: string) => {
        if (this.props.customPopover) {
            return this.props.customPopover;
        }
        const popOverTop = this.state.isLoading ?
            <Popover id="popover-positioned-top" className="footer-popover" title="Confirm Replace">
                <div style={loaderStyle} >
                    <CircularProgress size={50} color="#A4BF43" thickness={5} />
                </div>
                This form is already submitted.
            <br />
                {this.props.popOverContent}
                <strong>Do you want to replace this form?</strong>
                <FormFooter
                    submitLabel="Yes"
                    cancelLabel="No"
                    onCancel={() => document.body.click()}
                    onSubmit={() => this.deletePlant(plantUID, formType, outFall)}
                />
            </Popover>
            : <Popover id="popover-positioned-top" className="footer-popover" title="Confirm Replace">
                This form is already submitted.
            <br />
                <strong>Do you want to replace this form?</strong>
                {this.props.popOverContent}
                <FormFooter
                    submitLabel="Yes"
                    cancelLabel="No"
                    onCancel={() => document.body.click()}
                    onSubmit={() => this.deletePlant(plantUID, formType, outFall)}
                />
            </Popover>;
        return popOverTop;
    }

    render() {
        const { onClick, completedOutFalls, label, isClickable, id, plantUID } = this.props;
        return this.props.isVisible ? <div >
            <div
                onClick={isClickable ? () => onClick(id) : null}
                className={isClickable ? 'card-active card' : 'card-completed'}
            >
                {isClickable ?
                    <span>
                        {label}
                    </span> :
                    <OverlayTrigger
                        rootClose
                        trigger="click"
                        placement="top"
                        overlay={this.renderPopOverTop(plantUID, id, this.props.outfall || '')}
                    >
                        <span style={{
                            display: 'flex',
                            justifyContent: 'center'
                        }} >
                            <i className="fa fa-check-circle" aria-hidden="true"></i>
                            {<span>{label}</span>}
                        </span>
                    </OverlayTrigger>
                }
            </div>
        </div> :
            <div
                style={{ background: '#4c4c4c' }}
                className={'card-completed'}
                title={`${id} is not available for this plant`}
            >
                <span>
                    {label}
                </span>
            </div>;
    }
}

const loaderStyle: React.CSSProperties = {
    position: 'absolute',
    display: 'flex',
    width: '100%',
    left: 0,
    height: '78%',
    top: '31px',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 29,
    background: 'black',
    opacity: 0.7,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Summary/ListPage/FooterCard.tsx